<template>
    <v-app-bar
        app
        color="primary"
        dark
        clipped-left
    >
        <v-app-bar-nav-icon @click="$emit('toggleDrawer')"
                            v-if="isDashboard"
        />
        <router-link :to="{name: 'home'}">
            <div class="d-flex align-center">
                <v-img
                    alt="Noodzly"
                    class="shrink mr-2"
                    contain
                    src="/img/icons/android-chrome-512x512.png"
                    transition="scale-transition"
                    width="60"
                />
                <h3 class="white--text">
                    {{appName}}
                </h3>
            </div>
        </router-link>
        <v-spacer></v-spacer>
    </v-app-bar>
</template>

<script>
    import AuthUserDropdown from "./AuthUserDropdown";
    export default {
        name: "top-menu",
        props: {
            isDashboard: {
                default: false,
                type: Boolean
            }
        },
        computed: {
            appName() {
                return process.env.VUE_APP_APP_NAME ? process.env.VUE_APP_APP_NAME : "Noodzly"
            }
        },
        components: {AuthUserDropdown},
        data: function () {
            return {}
        },
    }
</script>

<style scoped>

</style>
